import { Dropdown } from '@symphony-ui/uitoolkit-components';
import Range from '../../../../../../models/data/Range';
import * as React from 'react';
import PopupContext from 'contexts/PopupContext';
import ValueBase from '../../../../../../models/data/ValueBase';
import ValueBaseEditor from './ValueBaseEditor';
const RangeEditor = ({ value, onChange }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [minimum, setMinimum] = React.useState(value?.min ?? new ValueBase({}));
    const [maximum, setMaximum] = React.useState(value?.max ?? new ValueBase({}));
    const [qualifier, setQualifier] = React.useState(value?.qualifier);
    const options = React.useMemo(() => ([
        { label: 'Area', value: 'AREA' },
        { label: 'WPIR', value: 'WPIR' },
        { label: 'Max.', value: 'MAX' }
    ]), []);
    const onChangeMinimum = React.useCallback((event) => {
        const newText = event.target.value;
        setMinimum(newText);
        if (newText.value) {
            const updated = value !== undefined ? value.updateMin(newText) : new Range({ min: newText, minimum: newText.value ?? 0, max: new ValueBase({}), maximum: 0 });
            onChange({ target: { value: updated } });
        }
    }, [onChange, value]);
    const onChangeMaximum = React.useCallback((event) => {
        const newText = event.target.value;
        setMaximum(newText);
        if (newText.value) {
            const updated = value !== undefined ? value.updateMax(newText) : new Range({ min: new ValueBase({}), minimum: 0, max: newText, maximum: newText.value ?? 0 });
            onChange({ target: { value: updated } });
        }
    }, [onChange, value]);
    const onChangeQualifier = React.useCallback((event) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        const newValue = event.target.value !== null ? event.target.value.value : undefined;
        setQualifier(newValue);
        if (value !== undefined) {
            const updated = value.updateQualifier(event.target.value.value);
            onChange({ target: { value: updated } });
        }
    }, [onChange, value]);
    const onMenuClose = React.useCallback(() => {
        setBlockClose(false);
    }, [setBlockClose]);
    const onMenuOpen = React.useCallback(() => {
        setBlockClose(true);
    }, [setBlockClose]);
    console.log("MIN: %o, MAX: %o", minimum, maximum);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(ValueBaseEditor, { label: "Minimum", value: minimum, onChange: onChangeMinimum }),
        React.createElement(ValueBaseEditor, { label: "Maximum", value: maximum, onChange: onChangeMaximum }),
        React.createElement("div", { className: 'co-dropdown-aligned', style: { marginRight: '0.5rem', width: '7rem' } },
            React.createElement(Dropdown, { isInputClearable: true, onChange: onChangeQualifier, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, options: options, value: options.find(o => o.value === qualifier) }))));
};
export default RangeEditor;
